import { createFileRoute } from "@tanstack/react-router";
import { pageHead } from "@/lib/routeHead";
import WhyBuyAnRV from "@/pages/WhyBuyAnRV";

export const Route = createFileRoute("/why-buy-an-rv")({
  head: () => pageHead({
    title: 'Why Buy an RV',
    description: 'Discover the freedom of RV travel — Rex & Sons RVs explains the benefits of RV ownership for families, couples and adventurers in North Carolina.',
    path: '/why-buy-an-rv',
  }),
  component: WhyBuyAnRV,
});
